import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setResourceType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const ResourceTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Resource Type"
      id="resource_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setResourceType(option.id))
      }}
    />
  )
}
export default ResourceTypeDropdown
